import { Typography, Button, Menu, MenuItem } from "@material-ui/core";
import axios from "axios";
import moment from "moment/moment";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { constants } from "../Helpers/constantsFile";
import { TextField } from "@mui/material";

const Leads = () => {
  const [leads, setLeads] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedLead, setSelectedLead] = useState(null);
  const [startDate, setStartDate] = useState(() => {
    const oneWeekAgo = moment().subtract(7, 'days').toISOString().split('T')[0];
    return oneWeekAgo;
  });
  const [endDate, setEndDate] = useState(new Date().toISOString().split('T')[0]);
  const token = useSelector(state => state.token.token);

  const readLeads = () => {
    axios
      .get(
        `${constants.baseUrl}/business-requests?startDate=${moment(startDate).format("YYYY-MM-DD")}&endDate=${moment(endDate).format("YYYY-MM-DD")}`,
        {
          headers: {
            authorization: token,
          },
        }
      )
      .then((res) => {
        console.log(res?.data?.data);
        // Sort leads by `created_at` in ascending order (earliest first)
        const sortedLeads = res?.data?.data?.businessRequests.sort(
          (a, b) => new Date(a.created_at) - new Date(b.created_at)
        );
        setLeads(sortedLeads);
      })
      .catch((err) => {
        console.log(err);
        alert(err.response?.data?.message);
      });
  };
  
  useEffect(() => {
    readLeads();
  }, [startDate, endDate]);

  const handleMenuOpen = (event, lead) => {
    setAnchorEl(event.currentTarget);
    setSelectedLead(lead);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setSelectedLead(null);
  };

  const handleStatusChange = (status, thislead) => {
    console.log(thislead)
    console.log(selectedLead)
    // Update the lead's status in your backend
    axios.patch(`${constants.baseUrl}/business-requests/${selectedLead.id}`, { status: status }, {
      headers: {
        'authorization': token
      },
    }).then(() => {
      // Update the lead's status in the local state
      setLeads(leads.map(lead => lead.id === selectedLead.id ? { ...lead, status } : lead));
      handleMenuClose();
    }).catch((err) => {
      console.log(err);
      alert(err.response?.data?.message);
    });
  };

  return (
    <div style={{ width: "93%", margin: "20px auto" }}>
      <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between", width: "100%" }}>
        <Typography style={{ fontSize: "22px", fontWeight: "bold" }}>
          Business Requests
        </Typography>
        <div style={{ marginBottom: '20px' }}>
          <TextField
            size="small"
            variant="outlined"
            type="date"
            label="Start Date"
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
            InputLabelProps={{
              shrink: true,
            }}
            style={{ marginRight: '20px' }}
          />
          <TextField
            size="small"
            variant="outlined"
            type="date"
            label="End Date"
            value={endDate}
            onChange={(e) => setEndDate(e.target.value)}
            InputLabelProps={{
              shrink: true,
            }}
            style={{ marginRight: '20px' }}
          />
        </div>
      </div>

      <div style={{ width: "100%", display: "flex", flexDirection: "column", gap: "12px" }}>
        {leads?.map((lead, index) => (
          <div key={lead.id} style={{
            display: "flex",
            cursor: "pointer",
            flexDirection: "row",
            background: "white",
            padding: "15px",
            alignItems: "center",
            borderRadius: "10px",
          }}>
            <Typography style={{ fontSize: "16px", flex: 0.2, color: "grey" }}> {index + 1}.</Typography>
            <Typography style={{ fontSize: "16px", flex: 2 }}> {lead?.business}</Typography>
            <Typography style={{ fontSize: "16px", flex: 1 }}> {lead?.phone}</Typography>
            <Typography style={{ fontSize: "16px", flex: 1 }}> {lead?.address ? lead?.address : "_______"}</Typography>
            <Typography style={{ fontSize: "16px", flex: 1 }}> {moment(lead?.date).format("YYYY-MM-DD")}</Typography>
            <Typography style={{ fontSize: "16px", color: lead?.status == "customer" ? "green" :
            lead?.status == "rejected" ? "red" :  lead?.status == "balan" ? "blue" : null,
              flex: 1 }}> {lead?.status}</Typography>
            <Button variant = "contained" onClick={(e) => handleMenuOpen(e, lead)}>Set Status</Button>
            <Menu
              anchorEl={anchorEl}
              keepMounted
              open={Boolean(anchorEl)}
              onClose={handleMenuClose}
            >
              {['customer', 'process', 'rejected', "balan"].map(status => (
                <MenuItem key={status} onClick={() => handleStatusChange(status, lead)}>
                  {status}
                </MenuItem>
              ))}
            </Menu>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Leads;
